import scrollPositionMixin from './scrollPositionMixin.js'

export default {
  data () {
    return {
      done: false
    }
  },
  mixins: [scrollPositionMixin],
  watch: {
    reached () {
      if (!this.done) {
        this.done = true
      }
    }
  },
  computed: {
    doneClass () {
      return {
        'is-done': this.done,
        'is-not-done': !this.done
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/doneMixin.js